import { getUsers, getUserGroups, GetUserParams, GetUserGroupParams, UserResponse, UserGroupResponse } from '../../shared';

export const usersQueries = {
  queries: {
    getUsers: (params: GetUserParams) => ({
      queryKey: ['shared', 'users', params],
      queryFn: async (): Promise<UserResponse> => {
        return await getUsers(params);
      }
    }),
    getUserGroups: (params: GetUserGroupParams) => ({
      queryKey: ['shared', 'user-groups', params],
      queryFn: async (): Promise<UserGroupResponse> => {
        return await getUserGroups(params);
      }
    })
  }
};
